import * as AOS from 'aos';

const Animations = () => {
    AOS.init();
};

export default Animations;


// WEBPACK FOOTER //
// ./src/js/app/components/Animations.js